export default __webpack_public_path__ + "static/media/tab_bg.06044237.png";